import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentType", "contentId", "parentId", "onSuccess", "onError"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { contentCommentSubscriptionQueryKeys } from 'actions/contentCommentSubscriptions';
import { playlistQueryKeys } from 'actions/playlists';
import { assetQueryKeys } from 'actions/assets';
import commentKeys from './queryKeys';
export function usePostComment(_ref) {
  var _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'asset' : _ref$contentType,
    contentId = _ref.contentId,
    _ref$parentId = _ref.parentId,
    parentId = _ref$parentId === void 0 ? null : _ref$parentId,
    _onSuccess = _ref.onSuccess,
    _onError = _ref.onError,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var queryKey = parentId ? commentKeys.contentCommentReplies(contentId, parentId) : commentKeys.contentComments(contentId);
  function postComment(_x) {
    return _postComment.apply(this, arguments);
  }
  function _postComment() {
    _postComment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('post', "/api/me/content/".concat(contentId, "/comments"), null, {
              parentId: parentId,
              message: message
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _postComment.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: postComment
    }, options), {}, {
      onSuccess: function onSuccess() {
        return Promise.all([queryClient.invalidateQueries({
          queryKey: contentType === 'playlist' ? playlistQueryKeys.allPlaylistAnalytics : assetQueryKeys.allAssetAnalytics
        }), queryClient.invalidateQueries({
          queryKey: queryKey
        }), queryClient.invalidateQueries({
          queryKey: contentType === 'playlist' ? playlistQueryKeys.singlePlaylist(contentId) : assetQueryKeys.singleAsset(contentId)
        }), queryClient.invalidateQueries({
          queryKey: contentCommentSubscriptionQueryKeys.contentSubscriptions(contentId)
        })]).then(function () {
          _onSuccess === null || _onSuccess === void 0 || _onSuccess();
          setSuccessAlert({
            title: t('alert_comment_posted_success')
          });
        });
      },
      onError: function onError() {
        _onError === null || _onError === void 0 || _onError();
        setAlert({
          title: t('alert_comment_posted_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    postComment: mutateAsync
  });
}
export default usePostComment;